import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
import { Constants } from 'src/app/config/constants';
import { CommonService } from 'src/app/lib/services/common.service';
import { LanguageService } from 'src/app/lib/services/language.service';
import { ProductsService } from 'src/app/lib/services/products.service';
import { StorageService } from 'src/app/lib/services/storage.service';

@Component({
  selector: 'app-category-modal',
  templateUrl: './category-modal.component.html',
  styleUrls: ['./category-modal.component.scss'],
  standalone: false
})
export class CategoryModalComponent implements OnInit {
  categories = [];
  searchLang: any;
  clickDisable: any;
  selectedCategories = [];
  masterCategoryArray: any;
  @Input() isModal: boolean;
  categoryPresentinBackend = []
  public categorySubject = new BehaviorSubject<string>('false');
  selectedtab = 'product';
  sellingType: boolean = true;
  disableProduct: boolean = false;
  disableService: boolean = false;
  isLoading: boolean = true;

  constructor(
    public commonService: CommonService,
    private storageService: StorageService,
    public languageService: LanguageService,
    private productsService: ProductsService,
    private modalController: ModalController,
  ) { }

  ngOnInit() { }

  ionViewWillEnter() {
    this.getSpashScreenData();
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  /**
   * @name getSpashScreenData
   * @type Function - Get all allCategories, microcategories, and products
   ***/
  async getSpashScreenData() {
    this.commonService.presentProgressBarLoading();
    const catalogPresentInStorage = await this.storageService.getItemNativeCatalog(Constants.MASTER_CATALOGUE);
    if (catalogPresentInStorage) {
      this.handleExistingCatalog(catalogPresentInStorage);
      this.commonService.closeProgressBarLoading();
    } else {
      try {
        const apiResponse = await this.productsService.getSplashApi().toPromise();
        this.commonService.closeProgressBarLoading();
        this.handleCatalogFromApiResponse(apiResponse);
      } catch (error) {
        this.commonService.closeProgressBarLoading();
        console.error('Error fetching splash API:', error);
      }
    }
  }

  async isSellingService(value: boolean) {
    this.commonService.presentProgressBarLoading();
    try {
      const res: any = await this.productsService.updateSellingType({ "service": value }).toPromise();
      // this.commonService.nativeToastMessage(res.data);
    } catch (error) {
      console.log(error);
    } finally {
      this.commonService.closeProgressBarLoading();
    }
  }

  getCategoriesData() {
    return this.masterCategoryArray.filter((res: any) => res.type == this.selectedtab);
  }

  handleExistingCatalog(catalogPresentInStorage: any) {
    const jsonObj = JSON.parse(catalogPresentInStorage);
    this.masterCategoryArray = jsonObj.masterCatalogData.catalog;
    this.getCatalogDataFromBackend();
  }

  async handleCatalogFromApiResponse(apiResponse: any) {
    if (apiResponse && apiResponse.data && apiResponse.data.catalogue_meta && apiResponse.data.catalogue_meta['masterCatalog']) {
      const urls = { masterCatalogData: apiResponse.data.catalogue_meta['masterCatalog'][0].url };
      try {
        const data = await this.productsService.homegetProductsListNew(urls).toPromise();
        if (data) {
          this.masterCategoryArray = data.masterCatalogData['catalog'];
          this.storageService.setItemNativeCatalog(Constants.MASTER_CATALOGUE, data);
          this.getCatalogDataFromBackend();
        }
      } catch (error) {
        console.error('Error fetching catalog data from backend:', error);
      }
    } else {
      console.error('Master catalog not found in API response');
    }
  }

  async getCatalogDataFromBackend() {
    const loading = await this.commonService.presentLoader();
    loading.present();
    try {
      this.selectedCategories = [];
      this.categoryPresentinBackend = [];
      const resp: any = await this.productsService.getCatalogList().toPromise();
      if (resp['success']) {
        this.isLoading = false;
        const retailerCatalog = resp['data'].catalog || [];
        const service = resp['data'].shop?.service;
        if (service) {
          this.selectedtab = 'service';
          retailerCatalog?.length ? this.disableProduct = true : '';
        } else {
          this.selectedtab = 'product';
          retailerCatalog?.length ? this.disableService = true : '';
        }
        const selectedCat = []
        this.selectedCategory(selectedCat, loading);
      }
    } catch (error) {
      loading.dismiss();
    }
  }

  async selectedCategory(categories: any, loading: any) {
    if (!categories || categories.length === 0) {
      loading.dismiss();
      return; // No need to proceed if there are no categories
    }
    try {
      const promises = categories.map((category: any) =>
        this.languageService.selectLanguageCDN(category.categoriesUrl).toPromise());
      const results = await Promise.all(promises);
      this.selectedCategories.push(...results);
    } catch (error) {
      this.commonService.errorToast(error);
      console.error(error);
    } finally {
      loading.dismiss();
    }
  }

  /**
   * @name chooseCategory
   * @type Function - Select/Unselect the allCategories
   * @param evt - Event triggred on click
   * @param id - Category Id
   * **/

  chooseCategory(category: any): void {
    this.commonService.presentLoader().then((loading: any) => {
      loading.present();
      this.languageService.selectLanguageCDN(category.categoriesUrl).subscribe(
        (categories: any) => {
          loading.dismiss();
          this.selectedCategories = [categories];
          this.masterCategoryArray.forEach((master: any) => {
            master.checked = (master.id === categories.id);
          });
        },
        (error) => {
          loading.dismiss();
          console.error('Error fetching categories:', error);
          this.commonService.presentToast('Failed to load categories. Please try again later.');
        }
      );
    }).catch((error) => {
      console.error('Error presenting loader:', error);
      this.commonService.presentToast('An error occurred. Please try again.');
    });
  }

  navigate() {
    if (this.selectedCategories.length) {
      this.storageService.setItemNativeCatalog(Constants.SELECTED_CATEGORIES, this.selectedCategories);
      this.dismissModalWithData(this.selectedCategories);
      this.dismissModal()
    } else {
      this.commonService.presentToast('Please choose a category to continue.');
    }
  }

  dismissModalWithData(data: any) {
    this.modalController.dismiss({ selectedCategories: data });
  }
}
